import { triniumApi } from '@api/Trinium/slice';
import { BaseApiRequest } from '@api/Trinium/types';
import {
  BillingWeekRecord,
  CommissionRecord,
  DeductionRecord,
  SettlementDetailRequest,
  SettlementLoadRecord,
  SettlementStatementRecord,
  SettlementSummaryRecord,
  YtdSummary,
  transformBillingWeekResponse,
  transformBillingYtdResponse,
  transformCommissionsResponse,
  transformDeductionsResponse,
  transformSettlementLoadsResponse,
  transformSettlementStatementResponse,
  transformSettlementSummaryResponse
} from './types';

export const settlementsSlice = triniumApi.injectEndpoints({
  endpoints(builder) {
    return {
      fetchStatements: builder.query<SettlementStatementRecord[], BaseApiRequest>({
        query: ({ terminalNumber }) => ({
          url: `/${terminalNumber}/settlements`
        }),
        transformResponse: transformSettlementStatementResponse
      }),

      fetchSettlementSummary: builder.query<SettlementSummaryRecord, SettlementDetailRequest>({
        query: ({ terminalNumber, statementId }) => ({
          url: `/${terminalNumber}/settlements/${String(statementId)}`
        }),
        transformResponse: transformSettlementSummaryResponse
      }),

      fetchSettlementLoads: builder.query<SettlementLoadRecord[], SettlementDetailRequest>({
        query: ({ terminalNumber, statementId }) => ({
          url: `/${terminalNumber}/settlements/${String(statementId)}/jobData`
        }),
        transformResponse: transformSettlementLoadsResponse
      }),

      fetchBillingWeek: builder.query<BillingWeekRecord[], SettlementDetailRequest>({
        query: ({ terminalNumber, statementId }) => ({
          url: `/${terminalNumber}/settlements/${String(statementId)}/billing`
        }),
        transformResponse: transformBillingWeekResponse
      }),

      fetchCommissions: builder.query<CommissionRecord[], SettlementDetailRequest>({
        query: ({ terminalNumber, statementId }) => ({
          url: `/${terminalNumber}/settlements/${String(statementId)}/commissionAdjs`
        }),
        transformResponse: transformCommissionsResponse
      }),

      fetchDeductions: builder.query<DeductionRecord[], SettlementDetailRequest>({
        query: ({ terminalNumber, statementId }) => ({
          url: `/${terminalNumber}/settlements/${String(statementId)}/deductions`
        }),
        transformResponse: transformDeductionsResponse
      }),

      fetchYtd: builder.query<YtdSummary, SettlementDetailRequest>({
        query: ({ terminalNumber, statementId }) => ({
          url: `/${terminalNumber}/settlements/${String(statementId)}/billingYtd`
        }),
        transformResponse: transformBillingYtdResponse
      })
    };
  }
});

export const {
  useFetchStatementsQuery,
  useFetchSettlementSummaryQuery,
  useFetchSettlementLoadsQuery,
  useFetchBillingWeekQuery,
  useFetchCommissionsQuery,
  useFetchDeductionsQuery,
  useFetchYtdQuery
} = settlementsSlice;
